import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import style from "./style.vue";

@Component({
	mixins: [style],
})
export default class Guide extends Vue {
	@Prop({ default: () => {} })
	value: ItemObject;

	@Prop()
	position: number;

	onActived() {
		this.$emit("click");
	}

	delGuide() {
		this.$emit("del");
	}

	renderLableAndDel(h) {
		return [
			<div class="label-button">小程序引导</div>,
			<div class="del-button" onClick={this.delGuide.bind(this)}>
				删除
			</div>,
		];
	}

	render(h) {
		return (
			<div class="guide">
				<img src="https://ssl-picture.tenyun.runsasoft.com/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E6%8C%89%E9%92%AE.png" class="capsule" style={`right: ${this.position}px !important`} />
				<div class={["guide-text", this.value.isActived && "is-actived"]} onClick={this.onActived.bind(this)} style={`right: ${this.position - 3}px !important`}>
					{this.value.desc.guideContent}
					{this.value.isActived && this.renderLableAndDel(h)}
				</div>
			</div>
		);
	}
}
